/* 
  处理订单状态
  create by 李智惠 2021-03-30
*/
// 中药处方划价单状态
export const drugCase = (obj) => {
  switch (obj.status) {
    case "-4": obj.statusStr = "已跑单"; break;
    case "-3": obj.statusStr = "快递退回"; break;
    case "-2": obj.statusStr = "已退款"; break;
    case "-1": obj.statusStr = "已作废"; break;
    case "0": obj.statusStr = "待支付"; break;
    case "2": obj.statusStr = "订单已生成"; break;
    case "3": obj.statusStr = "正在审方"; break;
    case "4": obj.statusStr = "正在配方"; break;
    case "5": obj.statusStr = "正在复审"; break;
    case "6": obj.statusStr = "正在加工"; break;
    case "7": obj.statusStr = "正在打包"; break;
    case "8": obj.statusStr = "正在配送"; break;
    case "9": obj.statusStr = "配送到达"; break;
    case "10": obj.statusStr = "订单完成"; break;
  }
}

// 隐秘处方划价单状态
export const comboCase = (obj) => {
  switch (obj.status) {
    case "-4": obj.statusStr = "已跑单"; break;
    case "-3": obj.statusStr = "快递退回"; break;
    case "-2": obj.statusStr = "已退款"; break;
    case "-1": obj.statusStr = "已作废"; break;
    case "0": obj.statusStr = "待支付"; break;
    case "2": obj.statusStr = "订单已生成"; break;
    case "3": obj.statusStr = "正在审方"; break;
    case "4": obj.statusStr = "正在配方"; break;
    case "5": obj.statusStr = "正在复审"; break;
    case "6": obj.statusStr = "正在打包"; break;
    case "7": obj.statusStr = "正在配送"; break;
    case "8": obj.statusStr = "配送到达"; break;
    case "9": obj.statusStr = "订单完成"; break;
  }
}

// 理疗处方划价单状态
export const physioCase = (obj) => {
  switch (obj.status) {
    case "-4": obj.statusStr = "已跑单"; break;
    case "-2": obj.statusStr = "已退款"; break;
    case "-1": obj.statusStr = "已作废"; break;
    case "0": obj.statusStr = "待支付"; break;
    case "1": obj.statusStr = "订单已生成"; break;
    case "2": obj.statusStr = "已完成"; break;
  }
}